<template>
  <div id="app_p" :style="$store.state.equipment.height">
    <van-tabs :color="tabcolor" v-model="active">
      <!-- 未完成 -->
      <van-tab title="未完成">
        <div class="tbody" v-for="(item, index) in order" :key="index">
          <div class="conent" v-if="item.payStatus === 'unpaid' || item.payStatus==='timeOut'">
            <div class="conentbox">
              <div class="conentboxrow">
                <div>订单编号:{{ item.orderNo }}</div>
                <div v-if="item.payStatus==='timeOut'">订单已超时</div>
              </div>
            </div>
            <h4 class="contentproject">
              {{ item.appraisalBatchName }}
            </h4>
            <div class="contentproject">考试科目：{{ item.subjectName }}</div>
            <div class="projectflex">
              <div>工种：{{ item.occupation }}</div>
              <div>考试等级：{{ item.skillLevel }}</div>
            </div>
            <div class="contentproject deactive" v-if="item.examTime != null">
              理论考试时间:{{ item.examTime }}
            </div>
            <div class="contentproject deactive" v-if="item.liveTime != null">
              实操考试时间:{{ item.liveTime }}
            </div>
            <div class="contentproject deactive">{{ item.created }}</div>
            <van-divider
              :style="{ color: '##EDEDED ', padding: '0', margin: '0',}"
            />
            <van-row type="flex" class="payRow">
              <van-col span="17">
                <span style="color:red"> ￥{{ item.payment }} </span>
              </van-col>
              <van-col>
                <div class="payButton" v-if="item.payStatus === 'unpaid'">
                  <van-button
                    class="btn_public"
                    type="danger"
                    size="mini"
                    @click="gopay(item.id)"
                  >
                    前往支付
                  </van-button>
                </div>

                <div class="payButton" v-if="item.payStatus === 'timeOut'">
                  <van-button
                    class="btn_public"
                    type="info"
                    size="mini"
                    @click="deleteOrder(item.id)"
                  >
                    删除
                  </van-button>
                  <van-button
                    class="btn_publics"
                    type="info"
                    size="mini"
                    @click="checkpay(item.id)"
                  >
                    查看
                  </van-button>
                </div>

               
              </van-col>
            </van-row>
          </div>
        </div>
      </van-tab>
      <!-- 已完成 -->
      <van-tab title="已完成">
        <div class="tbody" v-for="(item, index) in order" :key="index">
          <div class="conent" v-if="item.payStatus === 'payed'">
            <div class="conentboxrowis">
              <div>订单编号:{{ item.orderNo }}</div>
            </div>
            <h4 style="margin: 0 15px 0px 15px; padding-top: 10px">
              {{ item.appraisalBatchName }}
            </h4>
            <div class="contentproject">考试科目：{{ item.subjectName }}</div>
            <div class="projectflex">
              <div>工种：{{ item.occupation }}</div>
              <div>考试等级：{{ item.skillLevel }}</div>
            </div>
            <div class="contentproject deactive" v-if="item.examTime != null">
              理论考试时间:{{ item.examTime }}
            </div>
            <div class="contentproject deactive" v-if="item.liveTime != null">
              实操考试时间:{{ item.liveTime }}
            </div>
            <div style="margin: 5px 0 8px 15px" class="deactive">
              付款时间：{{
                $moment(item.payTime).format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
            <!-- <div class="row_footer">
              <div
                style="
                  margin-top: 19px;
                  margin-left: 12px;
                  color: red;
                  display: inline-block;
                  font-weight: 700;
                "
              >
                ￥{{ item.payment }}
              </div>
              <van-button
                @click="checkpay(item.id)"
                type="info"
                size="small"
                style="margin-right: 10px; margin-top: 13px"
                >&nbsp;&nbsp;&nbsp;查看&nbsp;&nbsp;&nbsp;</van-button
              >
            </div> -->
            <van-divider
              :style="{ color: '##EDEDED ', padding: '0', margin: '0',}"
            />
            <van-row type="flex" class="payRow">
              <van-col span="17">
                <span style="color:red">￥{{ item.goodsPrice }}</span>
              </van-col>
              <van-col>
                <div class="payButton">
                  <van-button
                    class="btn_public"
                    type="info"
                    size="mini"
                    @click="checkpay(item.id)"
                  >
                    查看
                  </van-button>
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template> 
<script>
import headerBox from "@/components/header.vue";
import { showaddres } from "@/api/apitotal";
export default {
  components: {
    headerBox,
  },
  data() {
    return {
      tabcolor: "#54B0FB",
      active: 0,
      order: [],
      time: 0.5 * 60 * 60 * 1000
    };
  },
  mounted() {
    this.userorder();
  },
  methods: {
    deleteOrder(id){
      const params={
        orderId:id
      }
      this.$http.put("ExamOrder/deleteOrder",params).then((res) => {
        if(res.data.success){
            alert("删除成功")
        }
      });
    },
    userorder() {
      this.$http.post("ExamOrder/orderShow").then((res) => {
        this.order = res.data.data.list;
        console.log('打印order',this.order)
      });
    },
    gopay(id) {
      this.$router.push({ path: "order_pinfo", query: { transOrder: id } });

      // this.$router.push({path:"order_pinfo", query:{transOrder:id}})
      // })
    },
    checkpay(id) {
      const params = {
        orderId: id,
      };
      this.$http.post("ExamOrder/orderParticulars", params).then((res) => {
        this.$router.push({
          path: "order_pinfomy",
          query: { transOrder: res.data.data.transOrder },
        });
      });
    },
  },
};
</script>

<style lang='less' scoped>
#app_p {
  background-color: #eee;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 28px;
  width: 100%;
  height: 100vh;
  ::v-deep .van-tabs--line .van-tabs__wrap {
    width: 100%;
    height: @tabheight;
  }
  .tbody {
    background-color: @backgroundcolor;
    .baseList {
      margin: 16px 32px 15px 32px;
    }
  }
}

.rightcha {
  float: left;
}
.centerwz {
  padding: 0px;
  font-size: 30px;
  line-height: 70px;
}
.conent {
  width: 750px;
  background-color: #fff;
  margin-bottom: 10px;
  .pay {
    line-height: 100px;
    height: 100px;
  }
  .conentboxrowis {
    line-height: @contH;
    display: flex;
    justify-content: flex-start;
    margin-top: 6px;
    padding: 0 @paddingpay;
    border-bottom: @allboxbordermin;
  }
  .row_footer {
    height: 100px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    margin-top: @circle;
    border-top: @allboxbordermin;
  }
  .projectflex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: @paddingorder @paddingpay 0 @paddingpay;
  }
  .contentproject {
    padding: @paddingorder 0 0 @paddingpay;
  }
  .conentbox {
    height: @contH;

    border-bottom: @allboxbordermin;
    // .contentproject{
    //   padding-left: @paddingpay;
    // }
    .conentboxrow {
      height: 100%;
      line-height: @contH;
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
      padding: 0 @paddingpay;

      .waitpay {
        color: red;
      }
    }
  }
}
.deactive {
  color: #797979;
}

#top {
  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color: @backgroundcolor;
  padding-bottom: @headerpb;
}
.payRow {
  line-height: 100px;
  height: 100px;
  padding: 0 0 0 32px;
}
.payButton {
  position: relative;
}
.btn_public {
  font-size: 24px;
  width: 156px;
  height: 64px;
  position: absolute;
  top: 16px;
}
.btn_publics {
  font-size: 24px;
  right: 40px;
  width: 156px;
  height: 64px;
  position: absolute;
  top: 16px;
}
</style>